import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { PhoneSection } from "@/components/AccountSettings";
import { useAuth } from "@/context/AuthContext";

export function RequirePhone() {
  const { user } = useAuth();
  const open = !!user && ["patient", "doctor", "partner"].includes(user.role) && !user.phone;
  return (
    <Dialog open={open}>
      <DialogContent className="max-w-lg [&>button]:hidden" onInteractOutside={(e) => e.preventDefault()} onEscapeKeyDown={(e) => e.preventDefault()} data-testid="require-phone-dialog">
        <DialogHeader><DialogTitle>Add your mobile number</DialogTitle>
          <DialogDescription>A verified mobile number is now required for every Nirogyam account. We use it for sign-in codes, appointment and order updates.</DialogDescription></DialogHeader>
        <PhoneSection />
      </DialogContent>
    </Dialog>
  );
}
